<template>
  <v-row row wrap>
    <template v-if="this.$store.getters.user.admin">
      <v-col cols="12" class="pb-0">
        <v-btn @click.native="handleRefreshMonitoring" text>
          Force refresh
        </v-btn>
      </v-col>
    </template>
    
    <template v-for="(dataset, name, index) in metrics">
      <v-col cols="12" v-if="index === 0" :key="index">
        <line-chart style="height: 400px" :dataset="dataset.graph_data" :options="dataset.options"></line-chart>
      </v-col>
      <v-col cols="6" v-else :key="index">
        <line-chart style="height: 250px" :dataset="dataset.graph_data" :options="dataset.options"></line-chart>
      </v-col>
    </template>
  </v-row>
</template>

<script>
  import LineChart from '../../../UIComponents/Charts/LineChart.vue'
  
  export default {
    components: {
      LineChart
    },
    props: {
      metrics: {
        type: Object,
        default: function(){
          return {}
        }
      },
    },
    methods: {
      handleRefreshMonitoring() {
        this.$emit('refreshMonitoringData')
      },
    }
  }
</script>